import { render, staticRenderFns } from "./TimelineShippingDetails.vue?vue&type=template&id=7140afb5&scoped=true"
import script from "./TimelineShippingDetails.vue?vue&type=script&lang=js"
export * from "./TimelineShippingDetails.vue?vue&type=script&lang=js"
import style0 from "./TimelineShippingDetails.vue?vue&type=style&index=0&id=7140afb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7140afb5",
  null
  
)

export default component.exports